import { LocationType } from "planning-portal-library/src/lib/core/domain/models/location-type";
import { LocationTypeWebEntity } from "./location-type-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";

export class LocationTypeWebRepositoryMapper extends Mapper<LocationTypeWebEntity, LocationType> {
    mapFrom(param: LocationTypeWebEntity): LocationType {
      return {
        id: param.id,
        name: param.name    
      };
    }
  
    mapTo(param: LocationType): LocationTypeWebEntity {
      return {
          id: param.id,
          name: param.name    
        };
    }
  }
  